var React = require('react');

function Ux (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"info","key":0}),React.createElement("path",{"d":"M18.6,10.3h-4c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h4c1.1,0,2-0.9,2-2v-6C20.6,11.2,19.7,10.3,18.6,10.3z","key":1}),React.createElement("path",{"d":"M9,3.2H5c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h4c1.1,0,2-0.9,2-2v-6C11,4.1,10.1,3.2,9,3.2z","key":2}),React.createElement("path",{"d":"M18.6,3.2h-4c-1.1,0-2,0.9-2,2v2c0,1.1,0.9,2,2,2h4c1.1,0,2-0.9,2-2v-2C20.6,4.1,19.7,3.2,18.6,3.2z","key":3}),React.createElement("path",{"d":"M9,14.3H5c-1.1,0-2,0.9-2,2v2c0,1.1,0.9,2,2,2h4c1.1,0,2-0.9,2-2v-2C11,15.2,10.1,14.3,9,14.3z","key":4})]);
}

Ux.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 24 24","style":{"enableBackground":"new 0 0 24 24"},"xmlSpace":"preserve"};

module.exports = Ux;

Ux.default = Ux;
